module.exports = __webpack_public_path__ + "img/New PACI Flow - New-5.36b411ce.png";